import { injectable } from 'power-di';
import { Scene } from 'phaser';

@injectable()
export class GameService {
    private scene: Scene;

    public setScene(scene: Phaser.Scene): void {
        this.scene = scene;
    }
}
